import { Typography } from "@mui/material";
import { KVCardRow } from "./CardContent";

export default function UtilityCardContent({ node }) {
  let content;

  if (node.data.utilityType === "api") {
    const utility = node.data.utilities[Object.keys(node.data.utilities)[0]];

    const fields = utility.fields.map((param) => {
      return (
        <Typography variant="body2" color={"#b5b5b5"}>
          {param.name}
        </Typography>
      );
    });

    content = (
      <div>
        <KVCardRow
          label="Name"
          value={node.data.advanced.customName}
        ></KVCardRow>
        <KVCardRow
          label="Description"
          value={node.data.advanced.description}
        ></KVCardRow>
        <KVCardRow label="Inputs" value={fields}></KVCardRow>
      </div>
    );
  } else {
    const customFunctionName = node.data.customFunction.name;
    const utility = node.data.utilities[customFunctionName];

    const fields = utility.fields.map((param) => {
      return (
        <Typography key={param.label} variant="body2" color={"#b5b5b5"}>
          {param.label}
        </Typography>
      );
    });

    content = (
      <div>
        <KVCardRow
          label="Custom Function Name"
          value={node.data.customFunction.name}
        ></KVCardRow>
        <KVCardRow
          label="Repository"
          value={node.data.customFunction.repoName}
        ></KVCardRow>
        <KVCardRow label="Description" value={utility.description}></KVCardRow>
        <KVCardRow label="Inputs" value={fields}></KVCardRow>
      </div>
    );
  }

  return content;
}
